<template>
  <nav-menu
    v-slot:default="slotProps"
    :color="scoreReport.color"
    :style="{ width: '200px' }"
  >
    <b-nav-item
      @click.prevent="slotProps.scrollIntoView('subscoreBreakdown')"
      class="tsny_text-mid tsny_nav-item"
      href="#subscoreBreakdown"
    >
      Subscore Breakdown
    </b-nav-item>
    <div v-for="(section, key) in navSections" :key="key">
      <b-nav-item
        :href="`#${key}`"
        @click.prevent="slotProps.scrollIntoView(key)"
        class="tsny_text-mid tsny_nav-item"
      >
        {{ section.name }}
      </b-nav-item>
      <b-nav vertical v-if="section.subsections">
        <b-nav-item
          v-for="(subsection, subKey) in section.subsections"
          :key="subKey"
          :href="`#${generateLink(subsection)}`"
          @click.prevent="slotProps.scrollIntoView(generateLink(subsection))"
          class="tsny_text tsny_nav-item tsny_nav-item-sub"
        >
          {{ subsection }}
        </b-nav-item>
      </b-nav>
    </div>
  </nav-menu>
</template>

<script>
import NavMenu from "../NavMenu";
import Constants from "../../services/Constants";
export default {
  name: "ScoreReportNav",
  components: { NavMenu },
  props: {
    scoreReport: {
      type: Object,
      default: null
    }
  },
  computed: {
    navSections() {
      return {
        ...(this.scoreReport.courseId === "SAT" && {
          Verbal: {
            name: "Reading and Writing",
            subsections: Constants.EXAM_SECTIONS.SAT.SUBSECTIONS.VERBAL
          },
          Math: {
            name: "Math",
            subsections: Constants.EXAM_SECTIONS.SAT.SUBSECTIONS.MATH
          }
        }),
        ...(this.scoreReport.courseId === "ACT" && {
          English: {
            name: "English"
          },
          Math: {
            name: "Math"
          },
          Reading: { name: "Reading" },
          Science: {
            name: "Science"
          }
        })
      };
    }
  },
  methods: {
    generateLink(name) {
      return name === "No Calculator" ? "noCalculator" : name;
    }
  }
};
</script>

<style scoped></style>
